import { render, staticRenderFns } from "./IDsList.vue?vue&type=template&id=49571314&scoped=true"
import script from "./IDsList.vue?vue&type=script&lang=js"
export * from "./IDsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49571314",
  null
  
)

export default component.exports